import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from "react";
import {
  SearchBox,
  Hits,
  Configure,
  Highlight,
  useSearchBox,
} from "react-instantsearch";
import { Spin } from "antd";
import { category } from "../../../constants/categoryFilter";
import SuggestionInput from "./suggestionInput";
import { debounce } from "lodash";

interface AlgoliaInputInterface {
  placeholder: string;
  handleSelection: any;
  defaultValue?: any;
  formRef?: any;
  productItem?: any;
  type: string;
  brand?: string;
  onChange?: any;
}

const AlgoliaInput: React.FC<AlgoliaInputInterface> = (props: any) => {
  const {
    placeholder,
    handleSelection,
    defaultValue,
    formRef,
    type,
    productItem,
    brand,
  } = props;
  const stringWithoutLastPart = defaultValue?.split("-+")[0];
  const [showList, setShowList] = useState(false);
  const hideNoResultDiv = useRef<HTMLDivElement | null>(null);
  const searchBox = useSearchBox();
  const [selectedValue, setSelectedValue] = useState<any>(null);
  const [showConfigure, setshowConfigure] = useState(false);
  const debouncedRefine = debounce((value: any) => {
    searchBox.refine(value);
  }, 300); // Adjust the delay as needed

  const handleProductSelect = useCallback(
    (product: any) => {
      setShowList(false);
      if (product) {
        debouncedRefine(product?.name);
        handleSelection(product);
        setSelectedValue(product);
      }
    },
    [debouncedRefine, handleSelection, searchBox]
  );

  useEffect(() => {
    if (formRef?.getFieldValue(`${type}_${productItem?.title}`) === undefined) {
      searchBox.clear();
    }
  }, [formRef?.getFieldValue(`${type}_${productItem?.title}`)]);

  const handlInputFocus = useCallback(() => {
    setshowConfigure(true);
  }, []);

  useEffect(() => {
    // if (stringWithoutLastPart?.length) {
    searchBox.refine(stringWithoutLastPart);
    // setSelectedProduct(defaultValue)
    // }
  }, [stringWithoutLastPart, selectedValue]);

  useEffect(() => {
    const handleClickedOutside = () => {
      if (hideNoResultDiv?.current) {
        hideNoResultDiv.current.style.display = "none";
      }
    };

    // Add event listener when the component mounts
    document.addEventListener("mousedown", handleClickedOutside);

    // Remove event listener when the component unmounts
    return () => {
      document.removeEventListener("mousedown", handleClickedOutside);
    };
  }, [hideNoResultDiv]);

  // Memoize the search box configuration
  const configureComponent = useMemo(() => {
    return showConfigure ? (
      <Configure
        hitsPerPage={10}
        facetFilters={[category[placeholder?.toLowerCase()]]}
      />
    ) : null;
  }, [showConfigure, placeholder]);

  return (
    <div className="algolia-input">
      <>
        <SearchBox
          placeholder={placeholder}
          searchAsYouType={true}
          loadingIconComponent={() => <Spin />}
          onBlur={(e?: any) => {
            if (!selectedValue) {
              //for when there is no selected item from list
              handleSelection({
                name: e?.target?.value,
                brand_name: brand,
              });
            }
            setShowList(false);
          }}
          onFocus={(val: any) => {
            setShowList(true);
            handlInputFocus();
          }}
          resetIconComponent={() =>
            searchBox.query?.length > 0 ? (
              <span>
                {formRef?.getFieldValue(`${type}_${productItem?.title}_brand`)}
              </span>
            ) : null
          }
          classNames={{
            root: "custom-design",
          }}
        />

        {configureComponent}

        {showList ? (
          <>
            <Hits
              hitComponent={({ hit }) => {
                return (
                  <div
                    onMouseDown={() => {
                      handleProductSelect(hit);
                    }}
                    className="res-product"
                  >
                    <Highlight
                      attribute="brand_name"
                      hit={hit}
                      className="res-product__brand"
                    />
                    <Highlight
                      attribute="name"
                      hit={hit}
                      className="res-product__title"
                    />
                  </div>
                );
              }}
            />
            <SuggestionInput hideNoResultDiv={hideNoResultDiv} />
          </>
        ) : null}
        {/* <CustomTextWithBrandName
          text={formRef?.getFieldValue(`${type}_${productItem?.title}_brand`)}
        /> */}
        <div className="hide-search-icons" />
      </>
    </div>
  );
};

export default AlgoliaInput;
